import { createStore, createHook, createActionsHook } from 'react-sweet-state';

// Shared open/close state for the "Convert to markdown" lossy-conversion
// confirmation dialog. The state is lifted out of `useMarkdownModeActions`
// so multiple call sites (the header overflow menu, the title `.md`-suffix
// gesture, future entry points) can open the same dialog instance — the
// dialog itself is rendered in one place (currently `MoreActions`) and
// reads `isOpen` from this store.
//
// Single global flag is fine: only one Live page editor is mounted at a
// time. If that ever changes, key by contentId.

type MarkdownLossyDialogState = {
	isLossyDialogOpen: boolean;
};

const initialState: MarkdownLossyDialogState = {
	isLossyDialogOpen: false,
};

export const MarkdownLossyDialogStore = createStore({
	initialState,
	actions: {
		openLossyDialog:
			() =>
			({ setState, getState }) => {
				if (!getState().isLossyDialogOpen) {
					setState({ isLossyDialogOpen: true });
				}
			},
		closeLossyDialog:
			() =>
			({ setState, getState }) => {
				if (getState().isLossyDialogOpen) {
					setState({ isLossyDialogOpen: false });
				}
			},
	},
	name: 'MarkdownLossyDialogStore',
});

export const useMarkdownLossyDialogState = createHook(MarkdownLossyDialogStore);
export const useMarkdownLossyDialogActions = createActionsHook(MarkdownLossyDialogStore);
